import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class UserReviewerRateStats {
  @Field(type => Int)
  lateCount!: number

  @Field(type => Int)
  allClaimsCount!: number

  @Field(type => Int)
  pcOfLateClaims!: number

  @Field(type => Int)
  onTimeReviewRate!: number
}
